// Portfolio Data - Website Projects

export const websiteProjects = [
  {
    id: 1,
    title: 'Restaurant Website - Modern Design',
    category: 'web',
    type: 'Restaurant Website',
    year: '2026',
    client: 'Deluxe Restaurant',
    status: 'live',
    featured: true,
    
    // Preview & Images
    thumbnail: '/portfolio/restaurant-preview.jpg',
    screenshots: [
      '/portfolio/restaurant-preview.jpg',
      '/portfolio/restaurant-menu.jpg',
      '/portfolio/restaurant-gallery.jpg'
    ],
    
    // Description
    description: {
      sq: 'Website modern për restorant me dizajn elegant, menu online, sistem rezervimi dhe galeri foto. Përfshin animacione të bukura, integrimin me Google Maps dhe formë kontakti.',
      en: 'Modern restaurant website with elegant design, online menu, booking system and photo gallery. Features beautiful animations, Google Maps integration and contact form.'
    },
    
    // Details
    features: {
      sq: [
        'Dizajn Elegant & Responsiv',
        'Menu Online Interaktiv',
        'Sistem Rezervimi',
        'Galeri Foto Profesionale',
        'Google Maps Integration',
        'Form Kontakti',
        'Animacione të Bukura',
        'SEO Optimized',
        'Mobile-First Design',
        'Fast Loading Speed'
      ],
      en: [
        'Elegant & Responsive Design',
        'Interactive Online Menu',
        'Booking System',
        'Professional Photo Gallery',
        'Google Maps Integration',
        'Contact Form',
        'Beautiful Animations',
        'SEO Optimized',
        'Mobile-First Design',
        'Fast Loading Speed'
      ]
    },
    
    // Technologies
    technologies: [
      'React',
      'Next.js',
      'Tailwind CSS',
      'Framer Motion',
      'Google Maps API',
      'Vercel'
    ],
    
    // Colors
    colors: ['#8B4513', '#D2691E', '#FFF8DC', '#2F4F4F'],
    
    // Links
    liveUrl: 'https://restaurant-web-ten-phi.vercel.app',
    githubUrl: null,
    
    // Stats
    stats: {
      loadTime: '1.5s',
      performance: '92',
      accessibility: '98',
      seo: '95'
    }
  },
  
  {
    id: 2,
    title: 'Contenta Marketing Agency',
    category: 'web',
    type: 'Marketing Agency Website',
    year: '2026',
    client: 'Contenta',
    status: 'live', // live, in-progress, completed
    featured: true,
    
    // Preview & Images
    thumbnail: '/portfolio/projects/contenta-thumb.jpg',
    screenshots: [
      '/portfolio/projects/contenta-thumb.jpg',
      '/hero/hero-image.jpg',
      '/services/web-dev.jpg'
    ],
    
    // Description
    description: {
      sq: 'Website profesional për agjenci marketingu me dizajn modern, animacione të avancuara dhe funksionalitet të plotë. Përfshin blog CMS, live chat, booking sistem dhe PWA support.',
      en: 'Professional marketing agency website with modern design, advanced animations and full functionality. Includes blog CMS, live chat, booking system and PWA support.'
    },
    
    // Details
    features: {
      sq: [
        'Dizajn Modern & Responsiv',
        'Blog CMS me Admin Panel',
        'Live Chat me AI Bot',
        'Booking System për Konsultime',
        'PWA Support (Offline Mode)',
        'SEO Optimized',
        'Multi-Language (Shqip/English)',
        'Dark/Light Theme',
        'Contact Form me EmailJS',
        'Analytics & Tracking'
      ],
      en: [
        'Modern & Responsive Design',
        'Blog CMS with Admin Panel',
        'Live Chat with AI Bot',
        'Consultation Booking System',
        'PWA Support (Offline Mode)',
        'SEO Optimized',
        'Multi-Language (Albanian/English)',
        'Dark/Light Theme',
        'Contact Form with EmailJS',
        'Analytics & Tracking'
      ]
    },
    
    // Technologies
    technologies: [
      'React',
      'Vite',
      'Tailwind CSS',
      'Framer Motion',
      'Firebase',
      'EmailJS',
      'PWA',
      'Vercel'
    ],
    
    // Colors
    colors: ['#D4AF37', '#C9A961', '#1a1614', '#E8DCC4'],
    
    // Links
    liveUrl: 'https://contenta.marketing',
    githubUrl: null, // private
    
    // Stats
    stats: {
      loadTime: '1.2s',
      performance: '95',
      accessibility: '100',
      seo: '100'
    }
  },
  
  {
    id: 3,
    title: 'E-Commerce Fashion Store',
    category: 'web',
    type: 'E-Commerce Platform',
    year: '2025',
    client: 'Fashion Boutique',
    status: 'completed',
    featured: true,
    
    thumbnail: '/services/social-media.jpg',
    screenshots: [
      '/services/social-media.jpg',
      '/blog/blog.jpg'
    ],
    
    description: {
      sq: 'Platform e-commerce e plotë për shitje online me shopping cart, payment integration, inventory management dhe customer portal.',
      en: 'Full e-commerce platform for online sales with shopping cart, payment integration, inventory management and customer portal.'
    },
    
    features: {
      sq: [
        'Shopping Cart & Checkout',
        'Payment Gateway Integration',
        'Product Catalog & Filtering',
        'User Authentication',
        'Order Management',
        'Inventory Tracking',
        'Reviews & Ratings',
        'Wishlist & Favorites'
      ],
      en: [
        'Shopping Cart & Checkout',
        'Payment Gateway Integration',
        'Product Catalog & Filtering',
        'User Authentication',
        'Order Management',
        'Inventory Tracking',
        'Reviews & Ratings',
        'Wishlist & Favorites'
      ]
    },
    
    technologies: [
      'Next.js',
      'TypeScript',
      'Stripe',
      'Prisma',
      'PostgreSQL',
      'Tailwind CSS',
      'Redux'
    ],
    
    colors: ['#000000', '#FFFFFF', '#FF6B6B', '#4ECDC4'],
    
    liveUrl: 'https://fashionstore-demo.com',
    githubUrl: null,
    
    stats: {
      loadTime: '1.5s',
      performance: '92',
      accessibility: '98',
      seo: '95'
    }
  },
  
  {
    id: 3,
    title: 'Restaurant & Reservation System',
    category: 'web',
    type: 'Restaurant Website',
    year: '2025',
    client: 'Fine Dining Restaurant',
    status: 'live',
    featured: false,
    
    thumbnail: '/services/content.jpg',
    screenshots: [
      '/services/content.jpg'
    ],
    
    description: {
      sq: 'Website për restorant me menu interaktiv, sistem rezervimi online, order online dhe galeri fotografish profesionale.',
      en: 'Restaurant website with interactive menu, online reservation system, online ordering and professional photo gallery.'
    },
    
    features: {
      sq: [
        'Menu Interaktiv me Çmime',
        'Sistem Rezervimi Online',
        'Order Online & Delivery',
        'Galeri Fotografish',
        'Location & Map Integration',
        'Events & Special Offers',
        'Customer Reviews',
        'Multi-Language Menu'
      ],
      en: [
        'Interactive Menu with Prices',
        'Online Reservation System',
        'Online Order & Delivery',
        'Photo Gallery',
        'Location & Map Integration',
        'Events & Special Offers',
        'Customer Reviews',
        'Multi-Language Menu'
      ]
    },
    
    technologies: [
      'React',
      'Node.js',
      'MongoDB',
      'Express',
      'Google Maps API',
      'Cloudinary'
    ],
    
    colors: ['#8B4513', '#D4A574', '#2C1810', '#F5F5DC'],
    
    liveUrl: 'https://restaurant-demo.com',
    githubUrl: null,
    
    stats: {
      loadTime: '1.8s',
      performance: '88',
      accessibility: '95',
      seo: '92'
    }
  },
  
  {
    id: 4,
    title: 'Real Estate Listings Platform',
    category: 'web',
    type: 'Property Listing Website',
    year: '2025',
    client: 'Real Estate Agency',
    status: 'completed',
    featured: false,
    
    thumbnail: '/services/logo-design.jpg',
    screenshots: ['/services/logo-design.jpg'],
    
    description: {
      sq: 'Platform për listim të pronave me search & filter të avancuar, virtual tours, map view dhe comparison tools.',
      en: 'Property listing platform with advanced search & filter, virtual tours, map view and comparison tools.'
    },
    
    features: {
      sq: [
        'Advanced Search & Filters',
        'Map View Integration',
        'Virtual Tour 360°',
        'Property Comparison',
        'Mortgage Calculator',
        'Agent Profiles',
        'Favorite Listings',
        'Email Notifications'
      ],
      en: [
        'Advanced Search & Filters',
        'Map View Integration',
        'Virtual Tour 360°',
        'Property Comparison',
        'Mortgage Calculator',
        'Agent Profiles',
        'Favorite Listings',
        'Email Notifications'
      ]
    },
    
    technologies: [
      'Vue.js',
      'Nuxt',
      'Supabase',
      'Mapbox',
      'Tailwind CSS'
    ],
    
    colors: ['#0066CC', '#00A8E8', '#F0F8FF', '#2C3E50'],
    
    liveUrl: 'https://realestate-demo.com',
    githubUrl: null,
    
    stats: {
      loadTime: '2.0s',
      performance: '85',
      accessibility: '93',
      seo: '90'
    }
  },
  
  {
    id: 5,
    title: 'Portfolio & Blog Template',
    category: 'web',
    type: 'Personal Portfolio',
    year: '2026',
    client: 'Freelance Designer',
    status: 'in-progress',
    featured: false,
    
    thumbnail: '/portfolio/projects/portfolio-cv.jpg',
    screenshots: ['/portfolio/projects/portfolio-cv.jpg'],
    
    description: {
      sq: 'Template modern për portfolio personal me blog, project showcase, contact form dhe smooth animations.',
      en: 'Modern template for personal portfolio with blog, project showcase, contact form and smooth animations.'
    },
    
    features: {
      sq: [
        'Project Showcase Grid',
        'Blog with Categories',
        'About & Skills Section',
        'Contact Form',
        'Smooth Animations',
        'Dark Mode',
        'Responsive Design',
        'Fast Loading'
      ],
      en: [
        'Project Showcase Grid',
        'Blog with Categories',
        'About & Skills Section',
        'Contact Form',
        'Smooth Animations',
        'Dark Mode',
        'Responsive Design',
        'Fast Loading'
      ]
    },
    
    technologies: [
      'Astro',
      'React',
      'TypeScript',
      'Tailwind CSS',
      'MDX'
    ],
    
    colors: ['#6366F1', '#8B5CF6', '#EC4899', '#F59E0B'],
    
    liveUrl: null,
    githubUrl: 'https://github.com/username/portfolio-template',
    
    stats: {
      loadTime: '0.8s',
      performance: '98',
      accessibility: '100',
      seo: '98'
    }
  }
]

// Filter categories
export const categories = [
  { id: 'all', label: { sq: 'Të Gjitha', en: 'All' } },
  { id: 'web', label: { sq: 'Websites', en: 'Websites' } },
  { id: 'ecommerce', label: { sq: 'E-Commerce', en: 'E-Commerce' } },
  { id: 'dashboard', label: { sq: 'Dashboard', en: 'Dashboard' } },
  { id: 'mobile', label: { sq: 'Mobile App', en: 'Mobile App' } }
]

// Get projects by category
export const getProjectsByCategory = (category) => {
  if (category === 'all') return websiteProjects
  return websiteProjects.filter(project => project.category === category)
}

// Get featured projects
export const getFeaturedProjects = () => {
  return websiteProjects.filter(project => project.featured)
}

// Get project by id
export const getProjectById = (id) => {
  return websiteProjects.find(project => project.id === id)
}
